module.exports = __webpack_public_path__ + "static/javascript-patterns-fd45595012ba2722f639557bdf56a1af.png";